import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import IconButton from '@material-ui/core/IconButton';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOffOutlined';
import VisibilityIcon from '@material-ui/icons/VisibilityOutlined';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import EditIcon from '@material-ui/icons/EditOutlined';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import pdfImg from './assets/pdf.png';
import vidImg from './assets/vid.png';
import styles from './FileItem.scss';

const COLORS_PALLETE = ['#85DED5', '#E2B744', '#B798F2'];
const COLORS_PALLETE_2 = ['#6EB8B0', '#BB9738', '#987EC9'];

export const FileItem = ({
  article,
  onEditArticle,
  onDeleteArticle,
  onToggleArticle,
  articleId,
  fileActionMenuId,
  setFileActionMenuId,
  anchorEl,
  setAnchorEl,
  setSelectedVidPrevUrl,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.card_and_text_below_container}>
        <div
          className={styles.card_container}
          onClick={() => {
            if (article.screenType === 'vid') {
              setSelectedVidPrevUrl(article.vidUrl.en);
            } else {
              window.open(article.pdfUrl.en, '_blank');
            }
          }}
          style={
            article.img
              ? {
                  background: `url(${article.img}) no-repeat left top`,
                  backgroundSize: '100% 100%',
                }
              : {
                  background: `transparent linear-gradient(180deg, ${
                    COLORS_PALLETE[article.gradientColorIndex || 0]
                  } 0%, ${
                    COLORS_PALLETE_2[article.gradientColorIndex || 0]
                  } 100%) 0% 0% no-repeat padding-box`,
                }
          }
        >
          <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', right: -10, top: -10 }}>
              {article.isEnabled ? null : (
                <VisibilityOffIcon
                  style={{
                    fontSize: 16,
                    color: 'white',
                    position: 'relative',
                    top: 10,
                    right: 15,
                  }}
                />
              )}
              <IconButton
                color="default"
                onClick={event => {
                  event.stopPropagation();
                  setFileActionMenuId(articleId);
                  setAnchorEl(event.currentTarget);
                }}
                style={{
                  backgroundColor: 'white',
                  padding: 2,
                  top: 5,
                  right: 5,
                }}
                size="small"
              >
                <MoreVertIcon style={{ fontSize: 14 }} />
              </IconButton>
            </div>
            <Popover
              id={articleId}
              open={fileActionMenuId === articleId}
              anchorEl={anchorEl}
              onClose={event => {
                event.stopPropagation();
                setFileActionMenuId(null);
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
            >
              <div className={styles.card_actions} style={{ padding: 10 }}>
                {!article.isEnabled ? (
                  <Button
                    onClick={e => {
                      e.stopPropagation();
                      setFileActionMenuId(null);
                      onToggleArticle();
                    }}
                    style={{
                      minWidth: 30,
                      alignSelf: 'start',
                      fontSize: '1.2rem',
                    }}
                  >
                    <VisibilityIcon
                      style={{
                        fontSize: 16,
                        cursor: 'pointer',
                        marginRight: 10,
                      }}
                    />
                    Show resource
                  </Button>
                ) : (
                  <Button
                    onClick={e => {
                      e.stopPropagation();
                      setFileActionMenuId(null);
                      onToggleArticle();
                    }}
                    style={{
                      minWidth: 30,
                      alignSelf: 'start',
                      fontSize: '1.2rem',
                    }}
                  >
                    <VisibilityOffIcon
                      style={{
                        fontSize: 16,
                        cursor: 'pointer',
                        marginRight: 10,
                      }}
                    />
                    Hide resource
                  </Button>
                )}
                <Button
                  onClick={e => {
                    e.stopPropagation();
                    onEditArticle();
                  }}
                  style={{ minWidth: 30, fontSize: '1.2rem' }}
                >
                  <EditIcon
                    style={{ fontSize: 16, cursor: 'pointer', marginRight: 10 }}
                  />
                  Edit resource
                </Button>
                <Button
                  onClick={e => {
                    e.stopPropagation();
                    onDeleteArticle();
                  }}
                  style={{ minWidth: 30, fontSize: '1.2rem' }}
                >
                  <DeleteIcon
                    style={{ fontSize: 16, cursor: 'pointer', marginRight: 10 }}
                  />
                  Delete resource
                </Button>
              </div>
            </Popover>
            <div className={styles.card_title}>
              <div className={styles.note}>
                <img
                  src={article.screenType === 'vid' ? vidImg : pdfImg}
                  style={{ width: 32, height: 32 }}
                />
                {article.isPublished ? null : (
                  <div className={styles.label}>UNPUBLISHED</div>
                )}
              </div>
              <div className={styles.card_title_text}>{article.title.en}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FileItem.propTypes = {
  article: PropTypes.object.isRequired,
  onEditArticle: PropTypes.func.isRequired,
  onDeleteArticle: PropTypes.func.isRequired,
  onToggleArticle: PropTypes.func.isRequired,
  articleId: PropTypes.string,
  fileActionMenuId: PropTypes.string,
  setFileActionMenuId: PropTypes.func,
  anchorEl: PropTypes.object,
  setAnchorEl: PropTypes.func,
  setSelectedVidPrevUrl: PropTypes.func,
};
